import { createAction, props } from '@ngrx/store';

export const scrollToJob = createAction(
  '[JOB ANCHOR ITEM] scroll to job',
  props<{ code: string }>()
);
